// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_l80r2o0{font-style:normal;font-weight:normal;font-size:16px;line-height:24px;-webkit-text-decoration:none;text-decoration:none;cursor:pointer;color:var(--primary-color);}\n", ""]);
// Exports
module.exports = exports;
